import React, { FormEvent, useContext, useEffect, useState } from "react";
import { Grid, Segment, Form, Button, Popup } from "semantic-ui-react";
import EmployeeFttbHourList from "./EmployeeFttbHourList";
import { observer } from "mobx-react-lite";
import EmployeeFttbHourStore from "../../../app/stores/employeefttbhourStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { CSVLink } from "react-csv";

const EmployeeFttbHourDashboard: React.FC = () => {
  const employeefttbhourStore = useContext(EmployeeFttbHourStore);
  const {
    submitting,
    searchEmployeeFttbHours,
    loadPayrollCycles,
    payrollcyclesByName,
    payrollcycleRegistry,
    employeefttbhournamesByDate,
  } = employeefttbhourStore;

  useEffect(() => {
    loadPayrollCycles();
  }, []);

  const [search, setSearch] = useState({
    tech: "portal",
    payRun: "",
    jobStartDate: "",
    jobEndDate: "",
    orderNo: "",
  });

  if (employeefttbhourStore.loadingInitial)
    return <LoadingComponent content="Loading FttbHours" />;

  const payrunOptions = payrollcyclesByName.map(function (payrun) {
    var option = {
      key: payrun.startYear + payrun.endYear + payrun.payRun,
      text: payrun.startYear + "-" + payrun.endYear + " " + payrun.payRun,
      value: payrun.startYear + "-" + payrun.endYear + "-" + payrun.payRun,
    };
    return option;
  });

  const handleSubmit = () => {
    searchEmployeeFttbHours(search);
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setSearch({ ...search, [name]: value });
  };

  return (
    <Segment>
      <Form onSubmit={handleSubmit}>
        <Grid columns={2}>
          <Grid.Column>
            <Form.Select
              label="Pay Run"
              onChange={(e, { name, value }) =>
                setSearch({ ...search, [name]: value })
              }
              options={payrunOptions}
              search
              name="payRun"
              placeholder="Pay Run"
              value={search.payRun}
              clearable
            />
          </Grid.Column>
          <Grid.Column>
            <div style={{ marginTop: "1rem" }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {payrollcycleRegistry.get(search.payRun) &&
                "From:\xa0\xa0" +
                  payrollcycleRegistry
                    .get(search.payRun)
                    .startDate.substr(0, 10)}
            </div>
            <div>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {payrollcycleRegistry.get(search.payRun) &&
                "To:\xa0\xa0" +
                  payrollcycleRegistry.get(search.payRun).endDate.substr(0, 10)}
            </div>
          </Grid.Column>
        </Grid>
        <Grid columns={2}>
          <Grid.Column>
            <Form.Input
              label="Job Start Date"
              onChange={handleInputChange}
              name="jobStartDate"
              type="date"
              placeholder="Date"
              clearable
              value={search.jobStartDate}
            />
          </Grid.Column>
          <Grid.Column>
            <Form.Input
              label="Job End Date"
              onChange={handleInputChange}
              name="jobEndDate"
              type="date"
              placeholder="Date"
              clearable
              value={search.jobEndDate}
            />
          </Grid.Column>
        </Grid>
        <Grid columns={2}>
          <Grid.Column>
            <Form.Input
              label="Work Order No."
              onChange={handleInputChange}
              name="orderNo"
              placeholder="Work Order No."
              value={search.orderNo}
            />
          </Grid.Column>
          <Grid.Column>
            <Button
              loading={submitting}
              floated="left"
              positive
              type="submit"
              content="Search"
              style={{ marginTop: "1.5rem" }}
            />
          </Grid.Column>
        </Grid>
      </Form>
      <CSVLink data={employeefttbhournamesByDate} filename={"fttblist.csv"}>
        <Popup
          content="Download as CSV"
          trigger={
            <Button
              icon="download"
              floated="right"
              style={{ marginTop: "-3rem" }}
            />
          }
        />
      </CSVLink>
      <EmployeeFttbHourList />
    </Segment>
  );
};

export default observer(EmployeeFttbHourDashboard);
